var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBidIncrement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.282,
    height: 37.342,
    viewBox: "0 0 33.282 37.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6211",
    "data-name": "Group 6211",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6207",
    "data-name": "Group 6207",
    transform: "translate(23.541 17.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3680",
    "data-name": "Path 3680",
    d: "M1287.516,577.881h-7.306a.812.812,0,0,1-.812-.812V558.4a.811.811,0,0,1,.812-.812h7.306a.811.811,0,0,1,.812.812V577.07A.811.811,0,0,1,1287.516,577.881Zm-6.494-1.624h5.682V559.211h-5.682Z",
    transform: "translate(-1279.398 -557.587)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6208",
    "data-name": "Group 6208",
    transform: "translate(2.435 25.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3681",
    "data-name": "Path 3681",
    d: "M1261.516,579.764h-7.306a.811.811,0,0,1-.812-.812V568.4a.811.811,0,0,1,.812-.812h7.306a.811.811,0,0,1,.812.812v10.553A.811.811,0,0,1,1261.516,579.764Zm-6.494-1.624h5.682v-8.93h-5.682Z",
    transform: "translate(-1253.398 -567.587)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6209",
    "data-name": "Group 6209",
    transform: "translate(12.988 21.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3682",
    "data-name": "Path 3682",
    d: "M1274.516,578.823h-7.306a.811.811,0,0,1-.812-.812V563.4a.811.811,0,0,1,.812-.812h7.306a.811.811,0,0,1,.812.812v14.612A.811.811,0,0,1,1274.516,578.823Zm-6.494-1.624h5.683V564.211h-5.683Z",
    transform: "translate(-1266.398 -562.587)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6210",
    "data-name": "Group 6210",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3683",
    "data-name": "Path 3683",
    d: "M1254.457,560.129a.812.812,0,0,1-.574-.238l-3.247-3.247a.813.813,0,0,1,0-1.148l12.177-12.177a.811.811,0,0,1,1.148,0l4.3,4.3,7.782-7.782-1.861-1.861a.812.812,0,0,1,.574-1.386h8.118a.811.811,0,0,1,.812.812v8.118a.811.811,0,0,1-1.386.574l-1.861-1.861-11.6,11.6a.811.811,0,0,1-1.148,0l-4.3-4.3-8.355,8.356A.809.809,0,0,1,1254.457,560.129Zm-2.1-4.059,2.1,2.1,8.356-8.356a.811.811,0,0,1,1.148,0l4.3,4.3,11.6-11.6a.811.811,0,0,1,1.148,0l1.049,1.05v-5.346h-5.346l1.049,1.05a.811.811,0,0,1,0,1.148l-8.93,8.93a.811.811,0,0,1-1.148,0l-4.3-4.3Z",
    transform: "translate(-1250.399 -536.587)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidIncrement);
export default __webpack_public_path__ + "static/media/bidIncrement.0f03860b74f3124f06cc3062b38a1d51.svg";
export { ForwardRef as ReactComponent };